<template>
  <v-select
    v-model="category"
    :error-messages="errors"
    outlined
    :loading="loading"
    :disabled="loading"
    label="Quarto"
    :items="getRooms"
    item-text="description"
    item-value="id"
  ></v-select>
</template>

<script>
import {
  mapGetters,
} from 'vuex'
import axios from '@/plugins/axios'

export default {

  components: {},
  props: {
    value: {},
    errors: {},
  },

  data: () => ({
    loading: false,
    category: '',
    roomCategorys: [],
  }),

  watch: {
    value(val) {
      this.category = val
    },
    category() {
      this.$emit('input', this.category)
      this.$emit('change')
    },

  },

  created() {
    this.roomCategorys = this.getRooms
    this.category = this.value

    // this.loading = true
    // axios
    //     .get('helper/get_room_categorys')
    //     .then(response => {
    //       this.roomCategorys = response.data
    //     })
    //     .finally(() => {
    //         this.loading = false
    //     })
  },
  computed: {
    ...mapGetters('select', ['getRooms']),
  },
  methods: {},
}
</script>
